import { render } from "./RestaurantSingle.vue?vue&type=template&id=1887137d"
import script from "./RestaurantSingle.vue?vue&type=script&lang=js"
export * from "./RestaurantSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__